import React, { useState } from 'react';
import Header from '../components/site/Header';
import Hero from '../components/site/Hero';
import About from '../components/site/About';
import Products from '../components/site/Products';
import Services from '../components/site/Services';
import Customers from '../components/site/Customers';
import Quality from '../components/site/Quality';
import Locations from '../components/site/Locations';
import Contact from '../components/site/Contact';
import Footer from '../components/site/Footer';
import Lightbox from '../components/site/Lightbox';
import ScrollTop from '../components/site/ScrollTop';
import ScrollProgress from '../components/site/ScrollProgress';
import CookieBanner from '../components/site/CookieBanner';
import CookiePreferences from '../components/site/CookiePreferences';
import CookiePrefsButton from '../components/site/CookiePrefsButton';
import Seo from '../components/site/Seo';

const Landing: React.FC<{ path?: string }> = ({ path = '/' }) => {
  const [lightbox, setLightbox] = useState<string[] | null>(null);

  return (
    <div className="rts-site">
      <Seo path={path} alternates structuredData />
      <ScrollProgress />
      <Header />
      <main>
        <Hero />
        <About />
        <Products onOpenGallery={setLightbox} />
        <Services onOpenGallery={setLightbox} />
        <Customers />
        <Quality />
        <Locations />
        <Contact />
      </main>
      <Footer />
      <Lightbox images={lightbox} onClose={() => setLightbox(null)} />
      <ScrollTop />
      <CookieBanner />
      <CookiePreferences />
      <CookiePrefsButton />
    </div>
  );
};

export default Landing;
